import { AnyRoute, createRoute, lazyRouteComponent } from '@tanstack/react-router'
import { NotFoundError } from 'commons/errors'
import { Request } from 'commons/utils/request'

import { DocTemplateDetailsSchema } from './DocTemplateDetailsSchema'

export const templateDetailsRoute = <T extends AnyRoute>(indexRoute: T) =>
  createRoute({
    getParentRoute: () => indexRoute,
    path: '$id',
    component: lazyRouteComponent(() => import('./TemplateDetails')),
    validateSearch: (search) => DocTemplateDetailsSchema.parse(search),
    beforeLoad: ({ params, ...all }) => {
      if ('id' in params) return { ...all, flatDeps: { id: Number(params.id) } }
      else throw new NotFoundError()
    },
    loader: async ({ location: { search }, context: { flatDeps } }) =>
      Request.post(Request.urls.bank.documentTemplateDetails, { id: flatDeps.id, ...search })
  })
